module.exports = __webpack_public_path__ + "img/logo_pmi.623ae7a7.jpg";